import { ModeService } from '../mode/mode.service';
import { TenantContextService } from './tenant-context.service';

export function initializeTenantContext(
  mode: ModeService,
  ctx: TenantContextService,
): () => void {
  return () => {
    if (!mode.isTenant()) return;
    ctx.load();
  };
}
